export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' }
];

export const LIFE_EXPECTANCY_OPTIONS = [
  { value: '<1_year', label: 'Less than 1 year' },
  { value: '1-2_years', label: '1-2 years' },
  { value: '2-5_years', label: '2-5 years' },
  { value: '5-10_years', label: '5-10 years' },
  { value: '>10_years', label: 'More than 10 years' }
];

export const DURATION_OPTIONS = [
  { value: 'short_term', label: 'Short-term (< 4 weeks)' },
  { value: 'long_term', label: 'Long-term (≥ 4 weeks)' },
  { value: 'unknown', label: 'Unknown' }
];

export const COMORBIDITIES = [
  'Dementia',
  'Chronic Kidney Disease (CKD)',
  'Peptic ulcer disease',
  'Heart failure',
  'Diabetes',
  'T2DM',
  'History of falls',
  'Hypertension',
  'Dyslipidemia',
  'Diabetic peripheral neuropathy',
  'Atrial fibrillation',
  'Stroke history',
  'COPD',
  'Asthma',
  'Depression',
  'Anxiety',
  'Unknown'
];

export const CFS_DESCRIPTIONS = {
  1: 'Very Fit',
  2: 'Well',
  3: 'Managing Well',
  4: 'Vulnerable',
  5: 'Mildly Frail',
  6: 'Moderately Frail',
  7: 'Severely Frail',
  8: 'Very Severely Frail',
  9: 'Terminally Ill'
};
